/* global document */
// @flow

import React from 'react';
import ReactDOM from 'react-dom';
import { CookiesProvider } from 'react-cookie';
import { IntlProvider, addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';
import { Router, browserHistory, match } from 'react-router';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloProvider } from 'react-apollo';
import localmedTracker from 'localmed-tracker';
import {
  createUniversalContext,
  UniversalContextProvider,
  getLocale,
} from 'localmed-react-app/client';
import { onError } from 'apollo-link-error';
import { ApolloLink } from 'apollo-link';

import { loadHotjar } from './shared/utils/tracking';
import scrollTo from './shared/utils/scrollTo';
import routes from './routes';

addLocaleData(en);
addLocaleData(es);

try {
  localmedTracker.init({ overrideAttribution: true });
} catch (error) {
  if (typeof console !== 'undefined') {
    // eslint-disable-next-line no-console
    console.error(`localmedTracker.init() failed with error: ${error}`);
  }
}

loadHotjar();

/* eslint-disable no-console */
const errorLink = onError(props => {
  const { graphQLErrors, networkError } = props;
  if (graphQLErrors) graphQLErrors.forEach(error => console.error(error));
  else if (networkError) console.error(networkError);
  else console.error('Unknown error in Apollo error link');
});
/* eslint-enable */

const connectionLink = new HttpLink({
  uri: global.CLIENT_ENV.CLIENT_GRAPHQL_URL,
  credentials: 'same-origin',
});

const isDevelopment: boolean = process.env.NODE_ENV !== 'production';
const apolloLinks: Array<any> = isDevelopment ? [errorLink, connectionLink] : [connectionLink];
const link = ApolloLink.from(apolloLinks);

const client = new ApolloClient({
  link,
  cache: new InMemoryCache().restore(global.CLIENT_ENV.APOLLO_STATE),
});

const render = process.env.NODE_ENV === 'production' ? ReactDOM.hydrate : ReactDOM.render;

function scrollToTopOnRouterChange(state) {
  if (state.action === 'PUSH') {
    scrollTo({ top: 0 });
  }
}

match({ history: browserHistory, routes }, (error, redirectLocation, renderProps) => {
  const { router, location } = renderProps;
  router.listen(scrollToTopOnRouterChange);
  render(
    <IntlProvider locale={getLocale(location)}>
      <UniversalContextProvider universalContext={createUniversalContext({ router })}>
        <ApolloProvider client={client}>
          <CookiesProvider>
            <Router {...renderProps} />
          </CookiesProvider>
        </ApolloProvider>
      </UniversalContextProvider>
    </IntlProvider>,
    document.getElementById('root')
  );
});



// WEBPACK FOOTER //
// ./src/index.js